import type Store from "@ember-data/store";
import type ApplicationInstance from "@ember/application/instance";

export function initialize(owner: ApplicationInstance): void {
  const store = owner.lookup("service:store") as Store;

  const nephro = store.peekRecord("therapeutical-area", "nephro");
  const pneumo = store.peekRecord("therapeutical-area", "pneumo");
  const cardio = store.peekRecord("therapeutical-area", "cardio");
  const hepato = store.peekRecord("therapeutical-area", "hepato");
  const onco = store.peekRecord("therapeutical-area", "onco");
  const mental = store.peekRecord("therapeutical-area", "mental");
  const diabete = store.peekRecord("therapeutical-area", "diabeto");
  const digest = store.peekRecord("therapeutical-area", "digest");

  const data = {
    "2951-2": [nephro, pneumo, cardio, hepato, onco],
    "2823-3": [nephro, pneumo, cardio, hepato, onco, digest],
    "2000-8": [nephro, pneumo, cardio, hepato, onco],
    "14879-1": [nephro, pneumo, cardio, hepato, onco],
    "2885-2": [nephro, pneumo, cardio, hepato, onco],
    "1963-8": [nephro, pneumo, cardio, hepato, onco],
    "14682-9": [nephro, pneumo, cardio, hepato, onco],
    "62238-1": [nephro, pneumo, cardio, hepato, diabete, digest],
    "77147-7": [nephro, pneumo, cardio, hepato, digest],
    "1988-5": [nephro, pneumo, cardio, hepato, mental, digest],
    "3084-1": [nephro, pneumo, cardio, hepato],
    "2345-7": [nephro, pneumo, cardio, hepato, onco],
    "22700-9": [nephro, pneumo, cardio, hepato],
    "2731-8": [nephro, pneumo, cardio, hepato],
    "1989-3": [nephro, pneumo, cardio, hepato, onco],
    "4548-4": [nephro, pneumo, cardio, hepato, mental, diabete],
    "2276-4": [nephro, pneumo, cardio, hepato, onco, digest],
    "3040-3": [nephro, pneumo, cardio, hepato, digest],
    "62466-8": [nephro, pneumo, cardio, hepato],
    "72493-0": [nephro, pneumo, cardio, hepato],
    "30428-7": [nephro, pneumo, cardio, hepato],
    "2093-3": [nephro, pneumo, cardio, hepato],
    "13457-7": [nephro, pneumo, cardio, hepato, onco, diabete],
    "2571-8": [nephro, pneumo, cardio, hepato, onco],
    "2157-6": [nephro, pneumo, cardio, hepato],
    "77348-1": [nephro, pneumo, cardio, hepato],
    "72671-1": [nephro, pneumo, cardio, hepato],
    "72676-0": [nephro, pneumo, cardio, hepato],
    "53828-0": [nephro, pneumo, cardio, hepato],
    "53834-8": [nephro, pneumo, cardio, hepato],
    "718-7": [nephro, pneumo, cardio, hepato, onco, digest],
    "777-3": [nephro, pneumo, cardio, hepato, onco],
    "6690-2": [nephro, pneumo, cardio, hepato, onco, mental],
    "26499-4": [nephro, pneumo, cardio, hepato, onco],
    "789-8": [nephro, pneumo, cardio, hepato],
    "14196-0": [nephro, pneumo, cardio, hepato],
    "800-3": [nephro, pneumo, cardio, hepato],
    "5902-2": [nephro, pneumo, cardio, hepato],
    "2324-2": [nephro, pneumo, cardio, hepato, digest],
    "4542-7": [nephro, pneumo, cardio, hepato],
    "2465-3": [nephro, pneumo, cardio, hepato],
    "1975-2": [nephro, pneumo, cardio, hepato, onco],
    "94507-1": [nephro, pneumo, cardio, hepato, onco, mental],
    "94505-5": [nephro, pneumo, cardio, hepato, onco, mental],
    "34366-5": [nephro, pneumo, cardio, hepato],
    "2889-4": [nephro, pneumo, cardio, hepato],
    "25145-4": [nephro, pneumo, cardio, hepato],
    "11475-1": [nephro, pneumo, cardio, hepato],
    "2955-3": [nephro, pneumo, cardio, hepato],
    "2828-2": [nephro, pneumo, cardio, hepato],
    "14683-7": [nephro, pneumo, cardio, hepato],
    "2888-6": [nephro, pneumo, cardio, hepato, digest],
    "14684-5": [nephro, pneumo, cardio, hepato],
    "30405-5": [nephro, pneumo, cardio, hepato],
    "30934-4": [nephro, pneumo, cardio, hepato],
    "6301-6": [nephro, pneumo, cardio, hepato],
    "22664-7": [nephro],
    "2075-0": [onco],
    "1920-8": [onco, nephro, pneumo, cardio, hepato, digest],
    "1742-6": [onco, nephro, pneumo, cardio, hepato, digest],
    "6768-6": [onco, nephro, pneumo, cardio, hepato, diabete],
    "2085-9": [onco],
    "1751-7": [onco, nephro, digest],
    "6875-9": [onco],
    "24108-3": [onco],
    "10334-1": [onco],
    "2039-6": [onco],
    "2857-1": [onco],
    "10886-0": [onco],
    "12841-3": [onco],
    "21198-7": [onco],
    "1834-1": [onco],
    "33762-6": [onco, nephro, pneumo, cardio, hepato],
    "3193-0": [onco],
    "15067-2": [onco],
    "10501-5": [onco],
    "2243-4": [onco],
    "33959-8": [onco],
    "10839-9": [onco],
    "6598-7": [onco, nephro, pneumo, cardio, hepato],
    "30376-8": [onco],
    "14334-7": [mental],
    "25462-3": [mental],
    "3432-2": [mental],
    "72659-6": [mental],
    "6948-4": [mental],
    "4086-5": [mental],
    "9318-7": [diabete],
    "72885-7": [pneumo],
    "32294-1": [nephro],
    "2132-9": [digest],
    "95237-4": [digest],
    "63557-3": [digest],
    "5187-0": [digest],
    "20447-9": [digest],
    "15212-4": [digest],
    "71772-8": [digest],
    "54067-4": [digest],
    "38445-3": [digest],
    "71773-6": [digest],
    "2956-1": [nephro],
    "25550-5": [nephro]
  };

  Object.entries(data).forEach(([id, therapeuticalAreas]) => {
    store.createRecord("default-bio-exam", {
      id,
      therapeuticalAreas
    });
  });
}

export default {
  after: "therapeutical-areas",
  initialize
};
